/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import {
  Directive,
  ElementRef,
  AfterViewInit,
  Renderer2,
  HostListener,
} from '@angular/core';

@Directive({
  selector: '[match-button-width]',
  standalone: false,
})
export class MatchButtonWidthDirective implements AfterViewInit {
  @HostListener('window:resize')
  onResize() {
    this.adjustWidth();
  }

  buttons: HTMLButtonElement[];

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit(): void {
    const buttonCollection: HTMLCollectionOf<HTMLButtonElement> =
      this.elementRef.nativeElement.getElementsByTagName('button');
    this.buttons = Array.from(buttonCollection);
    if (!this.buttons) {
      return;
    }
    this.adjustWidth();
  }

  adjustWidth() {
    let maxWidth = 0;
    this.buttons.forEach((b) => {
      if (b.offsetWidth > maxWidth) {
        maxWidth = b.offsetWidth;
      }
    });
    this.buttons.forEach((b) => {
      this.renderer.setStyle(b, 'min-width', maxWidth + 'px');
    });
  }
}
